import React from 'react'
import { WebCourses } from '../providers/courses/CoursesProvider';
import AnnouncementTab from './courses/intro/tabs/AnnouncementTab';
import CurriculumTab from './courses/intro/tabs/CurriculumTab';
import FAQTab from './courses/intro/tabs/FAQTab';
import OverviewTab from './courses/intro/tabs/OverviewTab';
import ReviewTab from './courses/intro/tabs/ReviewTab';
import Footer from './Sections/Footer'
import Header from './Sections/Header'

const CourseIntroScreen = ({ course = WebCourses[2] }) => {
    const etoiles = [];

    for (let index = 0; index < parseInt(course.average); index++) {
        etoiles.push(<span key={index} className="star"></span>);
    }

    return (
        <div id="wrapper">
            <Header />

            <div className="page-content">
                <div className="course-details-wrapper topic-1 uk-light">
                    <div className="container p-sm-0">

                        <div uk-grid="">
                            <div className="uk-width-2-3@m">

                                <div className="course-details">
                                    <h1> {course.title}</h1>
                                    <p> {course.description} </p>

                                    <div className="course-details-info mt-4">
                                        <ul>
                                            <li>
                                                <div className="star-rating">
                                                    <span className="avg"> {course.average} </span>
                                                    {etoiles}
                                                </div>
                                            </li>
                                            <li> <i className="icon-feather-users"></i> 1200 Inscrit </li>
                                        </ul>
                                    </div>

                                    <div className="course-details-info">

                                        <ul>
                                            <li> Créé par <a href="#"> {course.author} </a> </li>
                                            <li> Dernière mise à jour 10/2020</li>
                                        </ul>

                                    </div>
                                </div>
                                <nav className="responsive-tab style-5">
                                    <ul
                                        uk-switcher="connect: #course-intro-tab ;animation: uk-animation-slide-right-medium, uk-animation-slide-left-medium">
                                        <li><a href="#">Programme d'étude</a></li>
                                        <li><a href="#">Aperçu</a></li>
                                        <li><a href="#">FAQ</a></li>
                                        <li><a href="#">Annonces</a></li>
                                        <li><a href="#">Commentaires</a></li>
                                    </ul>
                                </nav>

                            </div>
                        </div>

                    </div>
                </div>
                <div className="container">

                    <div className="uk-grid-large mt-4" uk-grid="">
                        <div className="uk-width-2-3@m">
                            <ul id="course-intro-tab" className="uk-switcher mt-4">
                                <CurriculumTab />
                                <OverviewTab />
                                <FAQTab />
                                <AnnouncementTab />
                                <ReviewTab />
                            </ul>
                        </div>

                        <div className="uk-width-1-3@m">
                            <div className="course-card-trailer" uk-sticky="top: 10 ;offset:105 ; media: @m ; bottom:true">

                                <div className="course-thumbnail">
                                    <img src={course.image} alt="" />
                                    <a className="play-button-trigger show" href="#trailer-modal" uk-toggle=""> </a>
                                </div>

                                {/* <!-- video demo model --> */}
                                <div id="trailer-modal" uk-modal="">
                                    <div className="uk-modal-dialog">
                                        <button className="uk-modal-close-default mt-2  mr-1" type="button" uk-close=""></button>
                                        <div className="uk-modal-header">
                                            <h4> Vidéo d'annonce </h4>
                                        </div>
                                        <div className="video-responsive">
                                            <iframe src="https://www.youtube.com/embed/nOCXXHGMezU" className="uk-padding-remove"
                                                uk-video="automute: true" frameBorder="0" allowFullScreen
                                                uk-responsive=""></iframe>
                                        </div>

                                        <div className="uk-modal-body">
                                            <h3>Construire un site Web Responsive </h3>
                                            <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="p-3">

                                    <p className="my-3 text-center">
                                        <span className="uk-h1"> $12.99 </span>
                                        <s className="uk-h4 text-muted"> $19.99 </s>
                                        <s className="uk-h6 ml-1 text-muted"> $32.99 </s>
                                    </p>

                                    <p> ! A présent nous laissons à ce prix</p>

                                    <div className="uk-child-width-1-2 uk-grid-small mb-4" uk-grid="">
                                        <div>
                                            <a href="course-resume.html"
                                                className="uk-width-1-1 btn btn-default transition-3d-hover">
                                                <i className="uil-play"></i> Commencer </a>
                                        </div>
                                        <div>
                                            <a href="course-resume.html"
                                                className="btn btn-danger uk-width-1-1 transition-3d-hover">
                                                <i className="uil-heart"></i> Favoris </a>
                                        </div>
                                    </div>

                                    <p className="uk-text-bold"> Ce cours inclu </p>

                                    <div className="uk-child-width-1-2 uk-grid-small" uk-grid="">
                                        <div>
                                            <span><i className="uil-youtube-alt"></i> 28 heures vidéo</span>
                                        </div>
                                        <div>
                                            <span> <i className="uil-award"></i> Certificat </span>
                                        </div>
                                        <div>
                                            <span> <i className="uil-file-alt"></i> 12 Articles </span>
                                        </div>
                                        <div>
                                            <span> <i className="uil-video"></i> Hors ligne </span>
                                        </div>
                                        <div>
                                            <span> <i className="uil-award"></i> Certificat </span>
                                        </div>
                                        <div>
                                            <span> <i className="uil-clock-five"></i> Accès infini </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>

            <Footer />

        </div>
    )
}

export default CourseIntroScreen
